import { render } from "./blank.html?vue&type=template&id=4dc3f122&scoped=true&ts=true"
import script from "./blank.ts?vue&type=script&lang=ts"
export * from "./blank.ts?vue&type=script&lang=ts"

import "./blank.scss?vue&type=style&index=0&id=4dc3f122&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc3f122"]])

export default __exports__